'use client';

import { verifySessionByProductSku } from '@/server-actions/verify-session-by-product-sku';
import { useEffect } from 'react';

export default function Template({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const verifyProductSku = async () => {
      await verifySessionByProductSku();
    };
    verifyProductSku();
  }, []);

  return <>{children}</>;
}
